import moment from 'moment';
import { devLog, logger } from './logger';

export const isBetweenHours = (
  currentTime: moment.Moment,
  startHour: number,
  startMinute: number,
  endHour: number,
  endMinute: number
): boolean => {
  // 성능 최적화: moment 객체 재사용
  const currentHour = currentTime.hour();
  const currentMinute = currentTime.minute();
  const currentTimeInMinutes = currentHour * 60 + currentMinute;
  const startTimeInMinutes = startHour * 60 + startMinute;
  const endTimeInMinutes = endHour * 60 + endMinute;

  let result: boolean;

  // 야간 영업시간 처리 (endHour가 startHour보다 작은 경우)
  if (endHour < startHour) {
    // 야간 영업시간: 18:00 ~ 02:00 같은 경우
    result = currentTimeInMinutes >= startTimeInMinutes || currentTimeInMinutes <= endTimeInMinutes;
  } else {
    // 일반 영업시간: 09:00 ~ 18:00 같은 경우
    // 시작 시간: >= (해당 시간에 정확히 나타남)
    // 종료 시간: < (해당 시간에 정확히 사라짐)
    result = currentTimeInMinutes >= startTimeInMinutes && currentTimeInMinutes < endTimeInMinutes;
  }

  // 개발 모드에서만 로깅 (메모리 절약)
  if (process.env.NODE_ENV === 'development') {
    devLog('🔍 isBetweenHours Optimized:', {
      currentTime: currentTime.format('YYYY-MM-DD HH:mm:ss'),
      currentTimeInMinutes,
      startTimeInMinutes,
      endTimeInMinutes,
      result,
      isNightHours: endHour < startHour
    });
  }

  return result;
};

export const getCurrentDayIndex = (currentTime: moment.Moment, endHour?: number, startHour?: number): number => {
  // 야간 영업시간 처리 (endHour가 startHour보다 작은 경우)
  if (endHour !== undefined && startHour !== undefined && endHour < startHour) {
    // 현재 시간이 endHour 이전이면 전날의 영업시간으로 간주
    // 예: 18:00 ~ 02:00 영업시간에서 현재 시간이 01:00이면 전날(18:00 시작)의 영업시간
    if (currentTime.hour() < endHour) {
      return currentTime.clone().subtract(1, 'day').day();
    }
  }
  
  return currentTime.day();
}; 